import axiosInstance from "../axiosInstance";

export const createSizeChart = async (data) => {
    try {
        const response = await axiosInstance.post('/brand/size-charts', data);
        return response.data;
    } catch (error) {
        return error.response?.data || { success: false, message: 'An error occurred' };
    }
};

export const listSizeCharts = async () => {
    try {
        const response = await axiosInstance.get('/brand/size-charts');
        return response.data;
    } catch (error) {
        return error.response?.data || { success: false, message: 'An error occurred' };
    }
};

export const deleteSizeChart = async (id, nullify = false) => {
    try {
        const response = await axiosInstance.delete(`/brand/size-charts/${id}`, {
            params: { nullify: nullify ? 'true' : 'false' }
        });
        return response.data;
    } catch (error) {
        return error.response?.data || { success: false, message: 'An error occurred' };
    }
};
